import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles'

import { defaultSettings } from 'src/theme/settings-config'

import { createTheme } from './create-theme'

export function ThemeProvider({ themeOverrides, children, ...other }) {
  const theme = createTheme({
    settingsState: defaultSettings,
    themeOverrides
  })

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      {children}
    </ThemeVarsProvider>
  )
}
